import type { Client } from '~/types/models';

function normalizeText(value: unknown): string {
    return String(value || '').trim();
}

export function recommendClientOnboardingTemplateId(input: {
    client?: Partial<Client> | null;
    projectNames?: string[];
}): string {
    const client = input.client || {};
    const searchableText = [
        client.name,
        client.companyName,
        client.businessName,
        client.contactName,
        client.lifecycle?.notes,
        ...(Array.isArray(client.lifecycle?.tags) ? client.lifecycle.tags : []),
        ...(Array.isArray(input.projectNames) ? input.projectNames : []),
    ]
        .map(normalizeText)
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

    if (/\b(website|web design|web redesign|landing page|site build|site refresh|homepage|ecommerce|shopify|webflow)\b/.test(searchableText)) {
        return 'website-project-onboarding';
    }

    if (/\b(brand|branding|logo|identity|rebrand|visual identity|brand strategy)\b/.test(searchableText)) {
        return 'branding-project-onboarding';
    }

    return 'general-client-onboarding';
}
